import AudioRecorder from "audio-recorder-polyfill";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const mixin = {
  emits: ["getAudioFile"],
  created() {
    window.MediaRecorder = AudioRecorder;
  },
  data() {
    return {
      audioPermission: { audio: true },
      isRecording: false,
      isPlaying: false,
      audioChunks: [],
      audioBlob: null,
      audioSrc: null,
      mainStream: null,
      mediaRecorderState: null,
    };
  },
  methods: {
    async startRecording() {
      try {
        this.mainStream = await navigator.mediaDevices.getUserMedia(
          this.audioPermission
        );
        this.audioChunks = [];
        this.handleRecording();
      } catch (error) {
        console.warn(error.name);
        if (
          error.name == "NotFoundError" ||
          error.name == "DevicesNotFoundError"
        ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "مشکلی پیش آمد",
              icon: "XIcon",
              variant: "danger",
              text: "هیچ میکروفونی روی دستگاه شما یافت نشد.",
            },
          });
        } else if (
          error.name == "NotAllowedError" ||
          error.name == "PermissionDeniedError"
        ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "مشکلی پیش آمد",
              icon: "XIcon",
              variant: "danger",
              text: "برای ثبت یادداشت صوتی باید دسترسی میکروفون خود را فعال کنید",
            },
          });
        }
      }
    },
    handleRecording() {
      this.mediaRecorder = new MediaRecorder(this.mainStream);
      this.mediaRecorder.start();
      this.mediaRecorder.addEventListener("dataavailable", (event) => {
        this.audioChunks.push(event.data);
      });
      this.mediaRecorderState = "recording";
    },

    async stopRecording() {
      await this.mediaRecorder.addEventListener("stop", () => {
        this.audioBlob = new Blob(this.audioChunks, {
          type: this.mediaRecorder.mimeType,
        });
        this.audioSrc = URL.createObjectURL(this.audioBlob);
        this.$emit(
          "getAudioFile",
          new File([this.audioBlob], "voice.mp3", {
            type: this.mediaRecorder.mimeType,
          })
        );
      });
      if (this.mediaRecorder.state != "inactive") {
        this.mainStream.getTracks()[0].stop();
        this.mediaRecorder.stop();
      }
      this.mediaRecorderState = "inactive";
      this.isPlaying = true;
    },
  },
};

export default mixin;
